import theme from '@adsk/alloy-react-theme';

export const fieldStyles = { paddingBottom: '16px' };

export const labelStyles = {
  ...theme.typography.heading4,
  marginBottom: '8px',
};

export const dividerStyles = { margin: '6px 0 16px 0' };

export const getInlineEditStyle = (
  isAccountVariant,
  displayNone,
  activeEdit
) => ({
  minHeight: '20px',
  ...(isAccountVariant && !activeEdit && { marginLeft: '-13px' }),
  ...(!isAccountVariant && !displayNone && { marginLeft: '-13px' }),
  ...(!isAccountVariant && displayNone && { display: 'none' }),
  ...(!isAccountVariant && { paddingTop: 0, paddingBottom: 0 }),
});
